module.exports = __webpack_public_path__ + "vue-dist/img/no-result@2x.d0ca44e4.png";